module.exports = __webpack_public_path__ + "static/img/装饰5.c6a870d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰5.svg
// module id = dRGF
// module chunks = 2